import './MarketingTopNav.css';

import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import Button from '../Button';
import CloseButton from '../CloseButton';
import HamburgerIcon from '../HamburgerIcon';

const MarketingTopNav: React.FC = () => {
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);
  const logo = `${process.env.PUBLIC_URL}/logo.svg`;

  const handleMenuOpen = (): void => setMenuOpen(true);
  const handleMenuClose = (): void => setMenuOpen(false);
  const handleMenuNavigate = (routePath: string): void => {
    handleMenuClose();
    navigate(routePath);
  };

  return (
    <>
      <div
        className={`marketing-nav-overlay ${menuOpen ? 'open' : ''}`}
        onClick={handleMenuClose}
        aria-hidden="true"
      />
      <div className={`marketing-nav-side-menu ${menuOpen ? 'open' : ''}`}>
        <CloseButton onClick={handleMenuClose} />
        <button type="button" className="marketing-nav-menu-item" onClick={() => handleMenuNavigate('/')}>Home</button>
        <button type="button" className="marketing-nav-menu-item" onClick={() => handleMenuNavigate('/features')}>Features</button>
        <button type="button" className="marketing-nav-menu-item" onClick={() => handleMenuNavigate('/pricing')}>Pricing</button>
        <button type="button" className="marketing-nav-menu-item" onClick={() => handleMenuNavigate('/about')}>About</button>
        <button type="button" className="marketing-nav-menu-item" onClick={() => handleMenuNavigate('/demo')}>Demo</button>
        <button type="button" className="marketing-nav-menu-item" onClick={() => handleMenuNavigate('/contact')}>Contact</button>
        <div className="marketing-nav-menu-item marketing-nav-menu-item-last">
          <Button
            variant="primary"
            fullWidth
            onClick={() => {
              handleMenuClose();
              navigate('/login');
            }}
          >
            Sign In
          </Button>
        </div>
      </div>

      <header className="marketing-nav-header">
        <div className="marketing-nav-logo-wrap">
          <img src={logo} alt="CheerEval Logo" className="marketing-nav-logo" />
        </div>
        <HamburgerIcon onClick={handleMenuOpen} />
      </header>

      <hr className="marketing-nav-divider" />
    </>
  );
};

export default MarketingTopNav;
